(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-registration/assets/react/store/redux.js') >= 0) return;  svs.modules.push('/modules/player-registration/assets/react/store/redux.js');

'use strict';

const {
  reducer
} = svs.playerRegistration.store;
const combinedReducers = RTK.combineReducers({
  playerregistrationreact: reducer
});

svs.playerRegistration.store.createStore = function () {
  let preloaded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return RTK.configureStore({
    reducer: combinedReducers,
    preloadedState: preloaded
  });
};
const store = svs.playerRegistration.store.createStore();
const PlayerRegistrationReduxProvider = _ref => {
  let {
    children
  } = _ref;
  return React.createElement(ReactRedux.Provider, {
    store: store
  }, children);
};
svs.playerRegistration.store.PlayerRegistrationReduxProvider = PlayerRegistrationReduxProvider;

 })(window);